import { GridFilterModel, GridSortItem, GridSortModel } from '@mui/x-data-grid'
import { GridInitialStateCommunity } from '@mui/x-data-grid/models/gridStateCommunity'
import { ICustomGridSortModel, ITableQueryParams, ITableQueryDetail } from './types'
import { decodeBase64, encodeBase64, QueryParam, tryParseObject } from '../utils'

export interface ITableQueryParamModel {
  table?: string
}

class TableHelperBase {
  private extractTableQueryParams = <T>(data?: ITableQueryParams<T>): ITableQueryParams<T> => {
    if (!data) return {}
    const { pagination, filter, sort, loading } = data
    return { pagination, filter, sort, loading }
  }

  isEmpty = <T>(value: ITableQueryParams<T>, defaultValue?: ITableQueryParams<T>): boolean => {
    const obj = this.extractTableQueryParams<T>(value)
    const check1 = !obj.filter || obj.filter.items.filter((x) => !!x.value).length < 1
    const check2 = !value.filter?.quickFilterValues || value.filter.quickFilterValues.length < 1
    // const check3 =
    return check1 || check2
  }

  equalTableQueryParams = <T>(ti1?: ITableQueryParams<T>, ti2?: ITableQueryParams<T>): boolean => {
    return JSON.stringify(this.extractTableQueryParams<T>(ti1)) === JSON.stringify(this.extractTableQueryParams<T>(ti2))
  }

  mapInitialState = <T>(value?: ITableQueryParams<T>, initialState?: GridInitialStateCommunity): GridInitialStateCommunity => {
    if (!value) return initialState ?? {}
    return {
      pagination: { paginationModel: value.pagination },
      filter: { filterModel: value.filter as GridFilterModel },
      sorting: { sortModel: this.mapSortModel(value.sort) },
      ...initialState
    }
  }

  mapSortModel = <T>(value?: ICustomGridSortModel<T>): GridSortModel | undefined => {
    return value?.map<GridSortItem>((x) => ({ field: x.field.toString(), sort: x.sort }))
  }

  detectSearchType = (data: GridFilterModel): ITableQueryDetail => {
    const hasQuickSearch = data.quickFilterValues && data.quickFilterValues.length > 0
    const hasFilter = data.items && data.items.length > 0
    if (hasQuickSearch && !hasFilter) return 'quickSearch'
    if (hasFilter) return 'filter'
  }

  //#region Query Params
  private extractToUrlQuery = <TModel>(tableInfo: Partial<ITableQueryParams<TModel>>): Partial<ITableQueryParams<TModel>> => {
    const { filter, sort, pagination } = tableInfo
    const obj = { filter, sort, pagination }
    const isQuickSearchEmpty = !filter?.quickFilterValues?.filter((x) => !!x).length
    if (!filter?.items.length && isQuickSearchEmpty) {
      obj.filter = undefined
    }
    return obj
  }

  private equals = <TModel>(tableInfo: Partial<ITableQueryParams<TModel>>, tableInfoOld: Partial<ITableQueryParams<TModel>>) => {
    return JSON.stringify(this.extractToUrlQuery(tableInfo)) === JSON.stringify(this.extractToUrlQuery(tableInfoOld))
  }

  setUrlQuery = <TModel>(tableInfo: Partial<ITableQueryParams<TModel>>, defaultValue: ITableQueryParams<TModel>) => {
    try {
      if (!this.equals(tableInfo, defaultValue)) {
        const data = this.extractToUrlQuery(tableInfo)
        const tqp: ITableQueryParamModel = { table: encodeBase64(JSON.stringify(data)) }
        QueryParam.patch(tqp)
      } else {
        QueryParam.deletes<ITableQueryParamModel>('table')
      }
    } catch (error) {
      console.log('Set URL Query error:', error)
    }
  }

  getUrlQuery = <TModel>(defaultValue: ITableQueryParams<TModel>): ITableQueryParams<TModel> => {
    const temp = QueryParam.getAll() as ITableQueryParamModel
    if (!temp?.table) return defaultValue
    const data = tryParseObject<ITableQueryParams<TModel>>(decodeBase64(temp.table ?? ''), {})
    if (Object.keys(data).length < 1) return defaultValue
    return data
  }
  //#endregion
}

const TableHelper = new TableHelperBase()
export default TableHelper
